module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-card', {
    staticClass: "py-4"
  }, [_c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    staticClass: "px-2",
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    },
    domProps: {
      "innerHTML": _vm._s(_vm.err)
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": "",
      "py-2": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "id": "instanceId",
      "label": _vm.$lang.labels.instanceId,
      "readonly": "",
      "auto-grow": "",
      "rows": "1"
    },
    model: {
      value: (_vm.instance.instanceId),
      callback: function($$v) {
        _vm.$set(_vm.instance, "instanceId", $$v)
      },
      expression: "instance.instanceId"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.name,
      "readonly": ""
    },
    model: {
      value: (_vm.instance.name),
      callback: function($$v) {
        _vm.$set(_vm.instance, "name", $$v)
      },
      expression: "instance.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.status,
      "readonly": ""
    },
    model: {
      value: (_vm.instance.status),
      callback: function($$v) {
        _vm.$set(_vm.instance, "status", $$v)
      },
      expression: "instance.status"
    }
  })], 1), _vm._v(" "), (_vm.instance.currentVersion) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.currentVersion,
      "readonly": ""
    },
    model: {
      value: (_vm.instance.currentVersion),
      callback: function($$v) {
        _vm.$set(_vm.instance, "currentVersion", $$v)
      },
      expression: "instance.currentVersion"
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.instance.previousVersion) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.previousVersion,
      "readonly": ""
    },
    model: {
      value: (_vm.instance.previousVersion),
      callback: function($$v) {
        _vm.$set(_vm.instance, "previousVersion", $$v)
      },
      expression: "instance.previousVersion"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.macAddress,
      "readonly": ""
    },
    model: {
      value: (_vm.instance.macAddresses),
      callback: function($$v) {
        _vm.$set(_vm.instance, "macAddresses", $$v)
      },
      expression: "instance.macAddresses"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.moonUrl,
      "rules": [function (v) { return _vm.validURL(v) || ("" + (_vm.$lang.errors.notValidUrl)); }, function (v) { return _vm.checkIsJustHostname(v) || ("" + (_vm.$lang.errors.notValidUrl)); }]
    },
    model: {
      value: (_vm.instance.moonUrl),
      callback: function($$v) {
        _vm.$set(_vm.instance, "moonUrl", $$v)
      },
      expression: "instance.moonUrl"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": "",
      "px-3": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "option",
    attrs: {
      "label": _vm.$lang.labels.publicKeySun,
      "color": "primary",
      "hide-details": "",
      "readonly": ""
    },
    model: {
      value: (_vm.instance.sunQueuePublicKeyPresent),
      callback: function($$v) {
        _vm.$set(_vm.instance, "sunQueuePublicKeyPresent", $$v)
      },
      expression: "instance.sunQueuePublicKeyPresent"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md3": "",
      "px-3": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "option",
    attrs: {
      "label": _vm.$lang.labels.privateKeySun,
      "color": "primary",
      "hide-details": "",
      "readonly": ""
    },
    model: {
      value: (_vm.instance.sunQueuePrivateKeyPresent),
      callback: function($$v) {
        _vm.$set(_vm.instance, "sunQueuePrivateKeyPresent", $$v)
      },
      expression: "instance.sunQueuePrivateKeyPresent"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-checkbox', {
    staticClass: "option",
    attrs: {
      "label": _vm.$lang.labels.publicKeyMoon,
      "color": "primary",
      "hide-details": "",
      "readonly": ""
    },
    model: {
      value: (_vm.instance.moonQueuePublicKeyPresent),
      callback: function($$v) {
        _vm.$set(_vm.instance, "moonQueuePublicKeyPresent", $$v)
      },
      expression: "instance.moonQueuePublicKeyPresent"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.created,
      "readonly": ""
    },
    model: {
      value: (_vm.instance.createdOn),
      callback: function($$v) {
        _vm.$set(_vm.instance, "createdOn", $$v)
      },
      expression: "instance.createdOn"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "md6": "",
      "px-3": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.header.contactedOn,
      "readonly": ""
    },
    model: {
      value: (_vm.instance.lastContactOn),
      callback: function($$v) {
        _vm.$set(_vm.instance, "lastContactOn", $$v)
      },
      expression: "instance.lastContactOn"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "px-4",
    attrs: {
      "rwo": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "mx-0",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'moonInstances'
        })
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v("\n        " + _vm._s(_vm.$lang.actions.close) + "\n      ")], 1), _vm._v(" "), _c('div', {
    staticClass: "d-inline-flex"
  }, [_c('v-btn', {
    staticClass: "primary mr-0",
    attrs: {
      "disabled": !_vm.valid
    },
    on: {
      "click": function($event) {
        return _vm.submit()
      }
    }
  }, [_vm._v("\n          Update\n        ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mr-0",
    on: {
      "click": _vm.copyKey
    }
  }, [_vm._v("\n          Copy Instance ID\n        ")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-ead15cca","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/moonInstances/MoonInstanceDetails.vue
// module id = 439
// module chunks = 35